module.exports = __webpack_public_path__ + "img/bucket_stopped.aa277d2d.svg";